var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "{{amount}} €";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

(function () {
  function r(e, n, t) {
    function o(i, f) {
      if (!n[i]) {
        if (!e[i]) {
          var c = "function" == typeof require && require;
          if (!f && c) return c(i, !0);
          if (u) return u(i, !0);
          var a = new Error("Cannot find module '" + i + "'");
          throw ((a.code = "MODULE_NOT_FOUND"), a);
        }
        var p = (n[i] = { exports: {} });
        e[i][0].call(
          p.exports,
          function (r) {
            var n = e[i][1][r];
            return o(n || r);
          },
          p,
          p.exports,
          r,
          e,
          n,
          t
        );
      }
      return n[i].exports;
    }
    for (
      var u = "function" == typeof require && require, i = 0;
      i < t.length;
      i++
    )
      o(t[i]);
    return o;
  }
  return r;
})()(
  {
    1: [
      function (require, module, exports) {
        var COMPLETE = "complete",
          CANCELED = "canceled";
        function raf(e) {
          if ("requestAnimationFrame" in window)
            return window.requestAnimationFrame(e);
          setTimeout(e, 16);
        }
        function setElementScroll(e, t, n) {
          Math.max(0, t),
            Math.max(0, n),
            e.self === e
              ? e.scrollTo(t, n)
              : ((e.scrollLeft = t), (e.scrollTop = n));
        }
        function getTargetScrollLocation(e, t) {
          var n,
            l,
            i,
            o,
            r,
            a,
            s,
            c = e.align,
            f = e.target.getBoundingClientRect(),
            d = c && null != c.left ? c.left : 0.5,
            u = c && null != c.top ? c.top : 0.5,
            g = c && null != c.leftOffset ? c.leftOffset : 0,
            m = c && null != c.topOffset ? c.topOffset : 0,
            h = d,
            p = u;
          if (e.isWindow(t))
            (a = Math.min(f.width, t.innerWidth)),
              (s = Math.min(f.height, t.innerHeight)),
              (l = f.left + t.pageXOffset - t.innerWidth * h + a * h),
              (i = f.top + t.pageYOffset - t.innerHeight * p + s * p),
              (l -= g),
              (i -= m),
              (l = e.align.lockX ? t.pageXOffset : l),
              (i = e.align.lockY ? t.pageYOffset : i),
              (o = l - t.pageXOffset),
              (r = i - t.pageYOffset);
          else {
            (a = f.width), (s = f.height), (n = t.getBoundingClientRect());
            var E = f.left - (n.left - t.scrollLeft),
              S = f.top - (n.top - t.scrollTop);
            (l = E + a * h - t.clientWidth * h),
              (i = S + s * p - t.clientHeight * p),
              (l -= g),
              (i -= m),
              (l = Math.max(Math.min(l, t.scrollWidth - t.clientWidth), 0)),
              (i = Math.max(Math.min(i, t.scrollHeight - t.clientHeight), 0)),
              (l = e.align.lockX ? t.scrollLeft : l),
              (i = e.align.lockY ? t.scrollTop : i),
              (o = l - t.scrollLeft),
              (r = i - t.scrollTop);
          }
          return { x: l, y: i, differenceX: o, differenceY: r };
        }
        function animate(e) {
          var t = e._scrollSettings;
          if (t) {
            var n = t.maxSynchronousAlignments,
              l = getTargetScrollLocation(t, e),
              i = Date.now() - t.startTime,
              o = Math.min((1 / t.time) * i, 1);
            if (t.endIterations >= n)
              return (
                setElementScroll(e, l.x, l.y),
                (e._scrollSettings = null),
                t.end(COMPLETE)
              );
            var r = 1 - t.ease(o);
            if (
              (setElementScroll(
                e,
                l.x - l.differenceX * r,
                l.y - l.differenceY * r
              ),
              i >= t.time)
            )
              return (
                t.endIterations++,
                t.scrollAncestor && animate(t.scrollAncestor),
                void animate(e)
              );
            raf(animate.bind(null, e));
          }
        }
        function defaultIsWindow(e) {
          return e.self === e;
        }
        function transitionScrollTo(e, t, n, l, i) {
          var o,
            r = !t._scrollSettings,
            a = t._scrollSettings,
            s = Date.now(),
            c = { passive: !0 };
          function f(e) {
            (t._scrollSettings = null),
              t.parentElement &&
                t.parentElement._scrollSettings &&
                t.parentElement._scrollSettings.end(e),
              n.debug && console.log("Scrolling ended with type", e, "for", t),
              i(e),
              o &&
                (t.removeEventListener("touchstart", o, c),
                t.removeEventListener("wheel", o, c));
          }
          a && a.end(CANCELED);
          var d = n.maxSynchronousAlignments;
          return (
            null == d && (d = 3),
            (t._scrollSettings = {
              startTime: s,
              endIterations: 0,
              target: e,
              time: n.time,
              ease: n.ease,
              align: n.align,
              isWindow: n.isWindow || defaultIsWindow,
              maxSynchronousAlignments: d,
              end: f,
              scrollAncestor: l,
            }),
            ("cancellable" in n && !n.cancellable) ||
              ((o = f.bind(null, CANCELED)),
              t.addEventListener("touchstart", o, c),
              t.addEventListener("wheel", o, c)),
            r && animate(t),
            o
          );
        }
        function defaultIsScrollable(e) {
          return (
            "pageXOffset" in e ||
            ((e.scrollHeight !== e.clientHeight ||
              e.scrollWidth !== e.clientWidth) &&
              "hidden" !== getComputedStyle(e).overflow)
          );
        }
        function defaultValidTarget() {
          return !0;
        }
        function findParentElement(e) {
          if (e.assignedSlot) return findParentElement(e.assignedSlot);
          if (e.parentElement)
            return "body" === e.parentElement.tagName.toLowerCase()
              ? e.parentElement.ownerDocument.defaultView ||
                  e.parentElement.ownerDocument.ownerWindow
              : e.parentElement;
          if (e.getRootNode) {
            var t = e.getRootNode();
            if (11 === t.nodeType) return t.host;
          }
        }
        module.exports = function (e, t, n) {
          if (e) {
            "function" == typeof t && ((n = t), (t = null)),
              t || (t = {}),
              (t.time = isNaN(t.time) ? 1e3 : t.time),
              (t.ease =
                t.ease ||
                function (e) {
                  return 1 - Math.pow(1 - e, e / 2);
                }),
              (t.align = t.align || {});
            var l = findParentElement(e),
              i = 1,
              o = t.validTarget || defaultValidTarget,
              r = t.isScrollable;
            t.debug &&
              (console.log("About to scroll to", e),
              l ||
                console.error(
                  "Target did not have a parent, is it mounted in the DOM?"
                ));
            for (var a = []; l; )
              if (
                (t.debug && console.log("Scrolling parent node", l),
                o(l, i) &&
                  (r ? r(l, defaultIsScrollable) : defaultIsScrollable(l)) &&
                  (i++, a.push(l)),
                !(l = findParentElement(l)))
              ) {
                s(COMPLETE);
                break;
              }
            return a.reduce(
              (n, l, i) => transitionScrollTo(e, l, t, a[i + 1], s),
              null
            );
          }
          function s(e) {
            --i || (n && n(e));
          }
        };
      },
      {},
    ],
    2: [
      function (require, module, exports) {
        window.scrollIntoView = require("./scrollIntoView");
      },
      { "./scrollIntoView": 1 },
    ],
  },
  {},
  [2]
);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container, options = {}) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus(options);
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus(options);
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus(options);
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    this.resizeTimeout = null;
    this.resizeThrottled = false;

    if (navigator.platform === "iPhone") {
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    }

    window.addEventListener("resize", this.onWindowResize.bind(this));

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        if (summaryElement.classList.contains("trap-focus")) {
          !reducedMotion || reducedMotion.matches
            ? addTrapFocus()
            : summaryElement.nextElementSibling.addEventListener(
                "transitionend",
                addTrapFocus
              );
        }
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  onWindowResize(event) {
    if (!this.resizeThrottled) {
      this.resizeThrottled = true;

      if (
        window.matchMedia("(min-width: 1200px)").matches &&
        !this.mainDetailsToggle.hasAttribute("open")
      ) {
        this.mainDetailsToggle.open = true;
        this.mainDetailsToggle.classList.add("menu-opening");
        this.mainDetailsToggle
          .querySelector("summary")
          .setAttribute("aria-expanded", true);
        trapFocus(
          this.mainDetailsToggle,
          this.mainDetailsToggle.querySelector("summary")
        );
      }

      this.resizeTimeout = setTimeout(() => {
        this.resizeThrottled = false;
        clearTimeout(this.resizeTimeout);
      }, 250);
    }
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");

        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);

    if (this.header) {
      this.header.classList.remove("menu-open");
    }
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));

      if (this.getAttribute("data-instant-play")) {
        const poster = modal.querySelector('[id^="Deferred-Poster-"]');
        poster.click();

        setTimeout(() => {
          poster.parentNode.querySelector("video").play();
        }, 250);
      }

      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));

    if (this.dataset.autoplay == "true") {
      this.loadContent(false);
    }
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        console.log("got here");
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateDeliveryTimes();
    this.updateSKU();
    this.updateStockCountdown();
    this.updateIngredients();
    this.updateDangerWarnings();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );

    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input =
        productForm.querySelector('input[name="id"]') ||
        productForm.querySelector('input[name="items[0]id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  updateDeliveryTimes() {
    const deliveryTimes = this.querySelector(".product__delivery-times");

    if (!deliveryTimes) {
      return;
    }

    const deliveryTimesContent = deliveryTimes.querySelector(
      ".delivery-times__time"
    );

    if (
      !this.currentVariant ||
      !this.currentVariant.available ||
      !this.currentVariant.delivery_time.time
    ) {
      deliveryTimes.classList.add("hidden");
    } else {
      if (
        this.currentVariant.delivery_time.time &&
        this.currentVariant.available
      ) {
        deliveryTimes.classList.remove("hidden");
        deliveryTimesContent.innerText = this.currentVariant.delivery_time.time;
        deliveryTimesContent.style.color =
          this.currentVariant.delivery_time.color;
      }
    }
  }
  updateSKU() {
    const sku = this.closest(".product__info-container").querySelector(
      ".product__sku"
    );

    if (!sku) {
      return;
    }

    if (!this.currentVariant || !this.currentVariant.available) {
      sku.classList.add("hidden");
    } else {
      sku.classList.remove("hidden");
      sku.innerText = this.currentVariant.sku;
    }
  }
  updateStockCountdown() {
    const stockCountdown = document.getElementById("StockCountdown");

    if (stockCountdown) {
      if (!this.currentVariant || !this.currentVariant.available) {
        stockCountdown.classList.add("hidden");
      } else {
        const stockCountdownStock = stockCountdown.querySelector(
          ".product__stock-countdown-stock"
        );
        stockCountdown.classList.remove("hidden");
        stockCountdownStock.innerText = this.currentVariant.inventory_quantity;
      }
    }
  }

  updateIngredients() {
    const ingredientsSection = document
      .querySelector(".product__ingredients")
      .closest(".shopify-section");
    const ingredientsSectionId = ingredientsSection.id.replace(
      "shopify-section-",
      ""
    );

    if (ingredientsSection) {
      fetch(
        `${window.location.href}?preview_theme_id=168701690121&sections=${ingredientsSectionId}`
      )
        .then((res) => res.json())
        .then((data) => {
          const ingredientContent = this.getSectionInnerHTML(
            data[ingredientsSectionId]
          );
          console.log(ingredientContent);

          ingredientsSection.innerHTML = ingredientContent;
        });
    }
  }
  updateDangerWarnings() {
    const dangerWarningsSection = document
      .querySelector(".product__danger-warnings")
      .closest(".shopify-section");
    const dangerWarningsSectionId = dangerWarningsSection.id.replace(
      "shopify-section-",
      ""
    );

    if (dangerWarningsSection) {
      fetch(
        `${window.location.href}?preview_theme_id=168701690121&sections=${dangerWarningsSectionId}`
      )
        .then((res) => res.json())
        .then((data) => {
          const dangerWarningContent = this.getSectionInnerHTML(
            data[dangerWarningsSectionId]
          );

          dangerWarningsSection.innerHTML = dangerWarningContent;
        });
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();

    if (this.querySelector(".combo")) {
      this.initComboboxSelects();

      this.searchString = "";
      this.searchTimeout = null;

      this.selectActions = {
        Close: 0,
        CloseSelect: 1,
        First: 2,
        Last: 3,
        Next: 4,
        Open: 5,
        PageDown: 6,
        PageUp: 7,
        Previous: 8,
        Select: 9,
        Type: 10,
      };

      this.addEventListener("change", (e) => {
        if (e.target.id.indexOf("Combobox") < 0) {
          this.onVariantChangeCombobox(e);
        }
      });
    }
  }

  updateOptions(e) {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }

  getActionFromKey(event, menuOpen) {
    const { key, altKey, ctrlKey, metaKey } = event;
    const openKeys = ["ArrowDown", "ArrowUp", "Enter", " "];

    if (!menuOpen && openKeys.includes(key)) {
      return this.selectActions.Open;
    }
    if (key === "Home") {
      return this.selectActions.First;
    }
    if (key === "End") {
      return this.selectActions.Last;
    }
    if (
      key === "Backspace" ||
      key === "Clear" ||
      (key.length === 1 && key !== " " && !altKey && !ctrlKey && !metaKey)
    ) {
      return this.selectActions.Type;
    }
    if (menuOpen) {
      if (key === "ArrowUp" && altKey) {
        return this.selectActions.CloseSelect;
      } else if (key === "ArrowDown" && !altKey) {
        return this.selectActions.Next;
      } else if (key === "ArrowUp") {
        return this.selectActions.Previous;
      } else if (key === "PageUp") {
        return this.selectActions.PageUp;
      } else if (key === "PageDown") {
        return this.selectActions.PageDown;
      } else if (key === "Escape") {
        return this.selectActions.Close;
      } else if (key === "Enter" || key === " ") {
        return this.selectActions.CloseSelect;
      }
    }
  }

  getUpdatedIndex(currentIndex, maxIndex, action) {
    const pageSize = 10;

    switch (action) {
      case this.selectActions.First:
        return 0;
      case this.selectActions.Last:
        return maxIndex;
      case this.selectActions.Previous:
        return Math.max(0, currentIndex - 1);
      case this.selectActions.Next:
        return Math.min(maxIndex, currentIndex + 1);
      case this.selectActions.PageUp:
        return Math.max(0, currentIndex - pageSize);
      case this.selectActions.PageDown:
        return Math.min(maxIndex, currentIndex + pageSize);
      default:
        return currentIndex;
    }
  }

  initComboboxSelects() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));

    fieldsets.map((fieldset) => {
      const combo = fieldset.querySelector(".combo");

      if (combo) {
        const combobox = combo.querySelector("[role=combobox]");
        combobox.addEventListener("click", this.onComboboxClick.bind(this));
        combobox.addEventListener("keydown", this.onComboboxKeyDown.bind(this));

        const comboboxOptions = Array.from(
          combo.querySelectorAll("[role=option]")
        );

        comboboxOptions.map((option) => {
          option.addEventListener("click", (e) => {
            e.stopPropagation();
            this.onComboboxOptionClick(e);
          });
        });
      }
    });
  }

  onVariantChangeCombobox(e) {
    const option = document.querySelector(`#Combobox-${e.target.id}`);

    if (option) {
      const combo = option.closest(".combo");

      const listbox = combo.querySelector("[role=listbox]");
      const optionIndex = Array.from(listbox.children).indexOf(option);

      this.onComboboxOptionChange(option, optionIndex);
      this.selectComboboxOption(option, optionIndex);
    }
  }

  onComboboxClick(e) {
    this.updateComboboxState(e.currentTarget.closest(".combo"), true);
  }

  onComboboxKeyDown(e) {
    const { key } = e;

    const combo = e.currentTarget.closest(".combo");
    const comboBoxOpen = combo.classList.contains("combo--open");

    const max = combo.querySelectorAll("[role=option]").length - 1;
    const action = this.getActionFromKey(e, comboBoxOpen);

    switch (action) {
      case this.selectActions.Last:
      case this.selectActions.First:
        this.updateComboboxState(combo, true);
      case this.selectActions.Next:
      case this.selectActions.Previous:
      case this.selectActions.PageUp:
      case this.selectActions.PageDown:
        e.preventDefault();
        return this.onComboboxOptionChange(
          e.currentTarget,
          this.getUpdatedIndex(parseInt(combo.dataset.activeIndex), max, action)
        );
      case this.selectActions.CloseSelect:
        e.preventDefault();
        this.selectComboboxOption(
          e.currentTarget,
          parseInt(combo.dataset.activeIndex)
        );
      case this.selectActions.Close:
        e.preventDefault();
        return this.updateComboboxState(combo, false);
      case this.selectActions.Type:
        return this.onComboboxType(combo, key);
      case this.selectActions.Open:
        e.preventDefault();
        return this.updateComboboxState(combo, true);
    }
  }

  updateComboboxState(element, focus = false) {
    const combobox = element.querySelector("[role=combobox]");
    const comboboxOpen = element.classList.contains("combo--open");

    combobox.setAttribute("aria-expanded", `${!comboboxOpen}`);
    !comboboxOpen
      ? element.classList.add("combo--open")
      : element.classList.remove("combo--open");

    const activeComboboxOption = !comboboxOpen
      ? element.querySelector("[aria-selected=true]").id
      : "";
    combobox.setAttribute("aria-activedescendant", activeComboboxOption);

    focus && combobox.focus();
  }

  onComboboxOptionClick(e) {
    const combo = e.currentTarget.closest(".combo");
    const listbox = combo.querySelector("[role=listbox]");
    const optionIndex = Array.from(listbox.children).indexOf(e.currentTarget);

    this.onComboboxOptionChange(e.currentTarget, optionIndex);
    this.selectComboboxOption(e.currentTarget, optionIndex);
    this.updateComboboxState(combo, false);
  }

  selectComboboxOption(element, index) {
    const combo = element.closest(".combo");
    const combobox = combo.querySelector("[role=combobox]");

    combo.dataset.activeIndex = index;

    combobox.setAttribute("aria-activedescendant", element.id);

    const options = combo.querySelectorAll("[role=option]");
    [...options].forEach((option) => {
      option.setAttribute("aria-selected", "false");
    });

    combobox.innerHTML = options[index].innerHTML;

    options[index].setAttribute("aria-selected", "true");
  }

  getSearchString(char) {
    if (typeof this.searchTimeout === "number") {
      window.clearTimeout(this.searchTimeout);
    }

    this.searchTimeout = window.setTimeout(() => {
      this.searchString = "";
    }, 500);

    this.searchString += char;
    return this.searchString;
  }

  onComboboxType(element, letter) {
    const combo = element.closest(".combo");
    const combobox = combo.querySelector("[role=combobox]");
    const comboboxOpen = combo.classList.contains("combo--open");

    if (!comboboxOpen) {
      combo.classList.add("combo--open");
      combobox.setAttribute("aria-expanded", `true`);
      combobox.focus();
    }

    const options = Array.from(combo.querySelectorAll("[role=option]")).map(
      (option) => {
        return option.dataset.value;
      }
    );
    const searchString = this.getSearchString(letter);

    const searchIndex = this.getIndexByLetter(
      options,
      searchString,
      parseInt(combo.dataset.activeIndex) + 1
    );

    if (searchIndex >= 0) {
      this.onComboboxOptionChange(element, searchIndex);
      this.selectComboboxOption(element, searchIndex);
    } else {
      window.clearTimeout(this.searchTimeout);
      this.searchString = "";
    }
  }

  filterOptions(options = [], filter, exclude = []) {
    return options.filter((option) => {
      const matches = option.toLowerCase().indexOf(filter.toLowerCase()) === 0;
      return matches && exclude.indexOf(option) < 0;
    });
  }

  getIndexByLetter(options, filter, startIndex = 0) {
    const orderedOptions = [
      ...options.slice(startIndex),
      ...options.slice(0, startIndex),
    ];
    const firstMatch = this.filterOptions(orderedOptions, filter)[0];
    const allSameLetter = (array) =>
      array.every((letter) => letter === array[0]);

    if (firstMatch) {
      return options.indexOf(firstMatch);
    } else if (allSameLetter(filter.split(""))) {
      const matches = this.filterOptions(orderedOptions, filter[0]);
      return options.indexOf(matches[0]);
    } else {
      return -1;
    }
  }

  onComboboxOptionChange(element, index) {
    const combo = element.closest(".combo");
    const combobox = combo.querySelector("[role=combobox]");

    combo.dataset.activeIndex = index;

    combobox.setAttribute("aria-activedescendant", element.id);

    const options = combo.querySelectorAll("[role=option]");

    [...options].forEach((option) => {
      option.classList.remove("combo__option--current");
    });

    options[index].classList.add("combo__option--current");

    const relatedRadioButtonId = options[index].id.replace("Combobox-", "#");

    const relatedRadioButton =
      combo.parentNode.querySelector(relatedRadioButtonId);

    relatedRadioButton.checked = true;
    options[index].dispatchEvent(new Event("change", { bubbles: true }));
  }
}

customElements.define("variant-radios", VariantRadios);

class DetailsAccordion extends HTMLElement {
  constructor() {
    super();

    this.prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    this.classList.add("truncate-overflow");

    // Accordion
    this.details = this.querySelector("details");
    this.summary = this.details.querySelector("summary");
    this.content = this.details.querySelector(".details-accordion__content");

    this.accordionAnimation = null;
    this.accordionIsClosing = false;
    this.accordionIsExpanding = false;

    this.summary.addEventListener("click", (e) => this.onClickAccordion(e));

    // Read more

    if (
      this.content.scrollHeight > this.content.offsetHeight &&
      this.classList.contains("details-accordion--first")
    ) {
      this.readMoreLink = null;
      this.readMore = window.productStrings.readMore;
      this.readLess = window.productStrings.readLess;

      this.readMoreMaxHeight = getComputedStyle(this.content).getPropertyValue(
        "--content-max-height"
      );
      this.readMoreAnimation = null;
      this.readMoreIsClosing = false;
      this.readMoreIsExpanding = false;

      this.appendReadMoreLink();
    } else {
      this.classList.remove("truncate-overflow");
    }
  }
  appendReadMoreLink() {
    const readMoreLink = document.createElement("button");

    readMoreLink.type = "button";
    readMoreLink.innerText = this.readMore;
    readMoreLink.classList.add("details-accordion__read-more");

    this.readMoreLink = readMoreLink;

    readMoreLink.addEventListener("click", (e) => this.onClickReadMore(e));

    this.content.parentNode.insertBefore(
      readMoreLink,
      this.content.nextSibling
    );
  }
  onClickAccordion(e) {
    e.preventDefault();
    this.style.overflow = "hidden";

    if (this.accordionIsClosing || !this.details.open) {
      this.openAccordion();
    } else if (this.accordionIsExpanding || this.details.open) {
      this.shrinkAccordion();
    }
  }
  shrinkAccordion() {
    this.accordionIsClosing = true;

    const startHeight = `${this.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.accordionAnimation) {
      this.accordionAnimation.cancel();
    }

    if (!this.prefersReducedMotion) {
      this.accordionAnimation = this.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 200,
          easing: "ease-out",
        }
      );

      this.accordionAnimation.onfinish = () =>
        this.onAccordionAnimationFinish(false);
      this.accordionAnimation.oncancel = () =>
        (this.accordionIsClosing = false);
    }
  }
  openAccordion() {
    this.style.height = `${this.offsetHeight}px`;
    this.details.open = true;
    window.requestAnimationFrame(() => this.expandAccordion());
  }
  expandAccordion() {
    this.accordionIsExpanding = true;
    const startHeight = `${this.offsetHeight}px`;
    const endHeight = `${
      this.summary.offsetHeight + this.content.offsetHeight
    }px`;

    if (this.accordionAnimation) {
      this.accordionAnimation.cancel();
    }
    if (!this.prefersReducedMotion) {
      this.accordionAnimation = this.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 300,
          easing: "ease-out",
        }
      );

      this.accordionAnimation.onfinish = () =>
        this.onAccordionAnimationFinish(true);
      this.accordionAnimation.oncancel = () =>
        (this.accordionIsExpanding = false);
    }
  }
  onAccordionAnimationFinish(open) {
    this.details.open = open;
    this.accordionAnimation = null;
    this.accordionIsClosing = false;
    this.accordionIsExpanding = false;
    this.style.height = this.style.overflow = "";
  }
  onClickReadMore(e) {
    e.preventDefault();
    this.content.style.overflow = "hidden";

    if (
      this.readMoreIsClosing ||
      this.classList.contains("truncate-overflow")
    ) {
      this.openReadMore();
    } else if (
      this.readMoreIsExpanding ||
      !this.classList.contains("truncate-overflow")
    ) {
      this.shrinkReadMore();
    }
  }
  shrinkReadMore() {
    this.readMoreIsClosing = true;

    const startMaxHeight = `${this.content.offsetHeight}px`;
    const endMaxHeight = this.readMoreMaxHeight;

    if (this.readMoreAnimation) {
      this.readMoreAnimation.cancel();
    }

    if (!this.prefersReducedMotion) {
      this.readMoreAnimation = this.content.animate(
        {
          maxHeight: [startMaxHeight, endMaxHeight],
        },
        {
          duration: 200,
          easing: "ease-out",
        }
      );

      this.readMoreAnimation.onfinish = () =>
        this.onReadMoreAnimationFinish(false);
      this.readMoreAnimation.oncancel = () => (this.readMoreIsClosing = false);
    }
  }
  openReadMore() {
    this.content.style.maxHeight = `${this.content.scrollHeight}px`;
    window.requestAnimationFrame(() => this.expandReadMore());
  }
  expandReadMore() {
    this.readMoreIsExpanding = true;
    const startMaxHeight = `${this.readMoreMaxHeight}`;
    const endMaxHeight = `${this.content.scrollHeight}px`;

    if (this.readMoreAnimation) {
      this.readMoreAnimation.cancel();
    }
    if (!this.prefersReducedMotion) {
      this.readMoreAnimation = this.content.animate(
        {
          height: [startMaxHeight, endMaxHeight],
        },
        {
          duration: 300,
          easing: "ease-out",
        }
      );

      this.readMoreAnimation.onfinish = () =>
        this.onReadMoreAnimationFinish(true);
      this.readMoreAnimation.oncancel = () =>
        (this.readMoreIsExpanding = false);
    }
  }
  onReadMoreAnimationFinish(open) {
    if (open) {
      this.classList.remove("truncate-overflow");
      this.readMoreLink.innerText = this.readLess;
    } else {
      this.classList.add("truncate-overflow");
      this.readMoreLink.innerText = this.readMore;
    }
    this.readMoreAnimation = null;
    this.readMoreIsClosing = false;
    this.readMoreIsExpanding = false;
    this.content.style.maxHeight = "";
    this.content.style.overflow = "";
  }
}

customElements.define("details-accordion", DetailsAccordion);

class LanguageSelect extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector("select");

    if (!Weglot) {
      this.classList.add("hide");
      return;
    }

    let currentLang = Weglot.getCurrentLang();

    for (let i = 0; i < this.select.options.length; i++) {
      const option = this.select.options[i];

      if (option.value === currentLang) {
        option.selected = "selected";
      }
    }

    this.select.addEventListener("change", this.onSelectChange.bind(this));
    Weglot.on("languageChanged", this.afterSelectChanged.bind(this));
  }
  onSelectChange() {
    Weglot.switchTo(this.select.value);
  }
  afterSelectChanged(lang) {
    this.select.value = lang;
  }
}

customElements.define("language-select", LanguageSelect);

class MixAndMatchModal extends ModalDialog {
  constructor() {
    super();

    document.addEventListener(
      "click",
      (event) => {
        const openModals = document.querySelectorAll(
          ".mix-and-match__modal[open]"
        );

        if (
          openModals.length > 0 &&
          !event.target.closest(".mix-and-match__modal-content") &&
          !event.target.closest(".mix-and-match__modal-opener") &&
          !event.target.closest(".product-form__submit--select-first")
        ) {
          this.hide();
        }
      },
      false
    );
  }

  show(opener) {
    this.openedBy = opener;
    this.openedBy.classList.add("mix-and-match__modal-opener--opened");
    const popup = this.querySelector(".template-popup");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'), {
      preventScroll: true,
    });
    document.body.classList.add("mix-and-match-modal--open");
    window.pauseAllMedia();
  }

  hide() {
    super.hide();
    if (this.openedBy) {
      this.openedBy.classList.remove("mix-and-match__modal-opener--opened");
    }
    document.body.classList.remove("mix-and-match-modal--open");
  }

  connectedCallback() {}
}

customElements.define("mix-and-match-modal-dialog", MixAndMatchModal);

class MixAndMatch extends HTMLElement {
  constructor() {
    super();

    this.urlParams = new URLSearchParams(document.location.search);
    this.discount = this.dataset.discount || 0;
    this.blockId = this.getAttribute("id");

    (window.nd24 = window.nd24 || {}).mixandmatch =
      window.nd24.mixandmatch || {};

    window.nd24.mixandmatch.setId =
      window.nd24.mixandmatch.setId ||
      this.urlParams.get("bundle_id") ||
      Math.random()
        .toString(36)
        .substring(2, 8 + 2);

    window.nd24.mixandmatch.setKey = this.urlParams.get("bundle_key") || null;

    window.nd24.mixandmatch.selectedVariants = [];

    window.nd24.mixandmatch.additionalPrices = {
      ...window.nd24.mixandmatch.additionalPrices,
      ...{ [this.blockId]: 0 },
    };
    this.resetAll();
  }
  resetAll() {
    const allElements = this.querySelectorAll(
      ".mix-and-match__modal-opener-wrapper"
    );

    allElements.forEach((element) => element.remove());

    const template = this.querySelector(
      ".mix-and-match__template-slots"
    ).cloneNode(true);
    const templateSlot = template.content;

    this.querySelector(".mix-and-match__slots").insertBefore(
      templateSlot,
      this.querySelector(".mix-and-match__slots").firstChild
    );

    if (this.setProperty) {
      this.setProperty.remove();
    }
    if (this.setVariantProperty) {
      this.setVariantProperty.remove();
    }
    if (this.inputElementWrapper) {
      this.inputElementWrapper.innerHTML = "";
    }
    this.fetchVariants();
  }
  fetchVariants() {
    if (this.urlParams.get("bundle_id")) {
      fetch(routes.cart_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/json`,
        },
      })
        .then((res) => res.json())
        .then((cart) => {
          const cartItems = cart.items
            .filter((filterVariant) => {
              return (
                filterVariant.properties._BundleProduct ==
                  this.urlParams.get("bundle_id") &&
                !filterVariant.properties._BundleProducts &&
                filterVariant.properties._BundleSection == this.dataset.count
              );
            })
            .reverse();

          const bundleVariants = [];

          for (let i = 0; i < cartItems.length; i++) {
            const bundleVariant = cartItems[i];

            for (let j = 0; j < bundleVariant.quantity; j++) {
              bundleVariants.push({
                id: bundleVariant.key,
                optional: bundleVariant.properties._BundleProductOptional
                  ? true
                  : false,
                section: bundleVariant.properties._BundleSection,
              });
            }
          }

          if (bundleVariants && bundleVariants.length > 0) {
            window.nd24.mixandmatch.selectedVariants = bundleVariants;
          }

          const bundleVariantsUrl = this.urlParams
            .get("bundle_products")
            .split(",");

          if (
            !bundleVariants &&
            bundleVariants.length <= 0 &&
            window.nd24.mixandmatch.selectedVariants.length <= 0 &&
            bundleVariantsUrl
          ) {
            window.nd24.mixandmatch.selectedVariants = bundleVariantsUrl.map(
              (variant) => {
                return {
                  id: variant,
                };
              }
            );
          }
          this.init();
        });
    } else {
      this.init();
    }
  }
  init() {
    this.productForm = document.querySelector(".product-form form");
    this.productFormSubmit = document.querySelector(".product-form__submit");

    this.setProperty;
    this.setVariantProperty;

    let inputElementWrapper =
      document.querySelector(".mix-and-match__inputs") ||
      document.createElement("span");

    inputElementWrapper.className = "mix-and-match__inputs";
    this.productForm.append(inputElementWrapper);

    this.inputElementWrapper = this.productForm.querySelector(
      ".mix-and-match__inputs"
    );

    this.lockSubmitButton();
    this.prepareProductForm();
    this.prepareVariants();

    const mixAndMatchButtons = this.querySelectorAll(".mix-and-match__button");

    for (let i = 0; i < mixAndMatchButtons.length; i++) {
      const element = mixAndMatchButtons[i];
      element.addEventListener("click", this.selectProduct.bind(this));
    }

    const mixAndMatchRemoveButtons = this.querySelectorAll(
      ".mix-and-match__remove-button"
    );

    for (let i = 0; i < mixAndMatchRemoveButtons.length; i++) {
      const element = mixAndMatchRemoveButtons[i];
      element.addEventListener("click", this.removeItem.bind(this));
    }

    if (
      this.urlParams.get("bundle_id") &&
      !this.productFormSubmit.dataset.mixAndMatchListener
    ) {
      this.productFormSubmit.dataset.mixAndMatchListener = true;
      this.productFormSubmit.addEventListener("click", (event) => {
        event.preventDefault();

        const formData = new FormData();

        fetch(window.Shopify.routes.root + "cart.js", {
          method: "GET",
        })
          .then((response) => response.json())
          .then((data) => {
            const itemsToDelete = data.items.filter(
              (item) =>
                item.properties._BundleProduct ==
                this.urlParams.get("bundle_id")
            );

            for (const item of itemsToDelete) {
              formData.append(`updates[${item.key}]`, 0);
            }

            fetch(window.Shopify.routes.root + "cart/update.js", {
              method: "POST",
              body: formData,
            }).then(() => {
              this.productFormSubmit
                .closest("form")
                .dispatchEvent(new Event("submit"));
            });
          });
      });
    }
  }
  prepareVariants() {
    if (window.nd24.mixandmatch.selectedVariants.length > 0) {
      const variants = window.nd24.mixandmatch.selectedVariants.filter(
        (variant) => {
          return variant.section == this.dataset.count;
        }
      );

      let slots = this.querySelectorAll(".mix-and-match__slot--empty");
      let slotIndex = 0;

      if (variants.length > slots.length) {
        for (let i = 0; i < variants.length - slots.length; i++) {
          const additionalTemplate = this.querySelector(
            ".mix-and-match__additional-slot"
          ).cloneNode(true);
          const additionalSlot = additionalTemplate.content;
          additionalSlot
            .querySelector(".mix-and-match__remove-button")
            .addEventListener("click", this.removeItem.bind(this));

          this.querySelector(".mix-and-match__slots").appendChild(
            additionalSlot
          );
        }
      }

      slots = this.querySelectorAll(".mix-and-match__slot--empty");

      for (let i = 0; i < variants.length; i++) {
        const id = variants[i].id.split(":")[0];
        const key = variants[i].id;

        const variantButton = this.querySelector(
          `.mix-and-match__button[data-variant='${id}']`
        );

        if (!variantButton) {
          continue;
        }

        const image = variantButton.querySelector(".mix-and-match__image");

        if (image) {
          const imageClone = image.cloneNode(true);

          const slot = slots[slotIndex];

          if (!slot) {
            continue;
          }

          const slotButton = slot.closest(".mix-and-match__modal-button");

          const isOptional = slotButton.querySelector(
            ".mix-and-match__slot--optional"
          );

          slot.innerHTML = "";
          slot.append(imageClone);
          slot.classList.remove("mix-and-match__slot--empty");

          slotButton.classList.add("mix-and-match__modal-button--selected");
          slotButton
            .closest(".mix-and-match__modal-opener-wrapper")
            .classList.add("mix-and-match__modal-opener-wrapper--selected");
          slotButton.setAttribute("data-variant-selected", key);
          slotButton.setAttribute(
            "data-variant-price",
            variantButton.dataset.price
          );
        }

        slotIndex++;
      }

      this.checkEmptySlots();
      this.setVariantInputs(window.nd24.mixandmatch.selectedVariants);

      const selectedVariants = document.querySelectorAll(
        ".mix-and-match__modal-button--selected"
      );

      const selectedVariantsIds = Array.from(selectedVariants).map(
        (selectedVariant) => {
          return {
            id: selectedVariant.dataset.variantSelected,
            optional: selectedVariant.querySelector(
              ".mix-and-match__slot--optional"
            )
              ? true
              : false,
            section: selectedVariant.closest("mix-and-match").dataset.count,
          };
        }
      );

      this.setSelectedVariants();
      this.setVariantInputs(selectedVariantsIds);
    }
  }

  setProductPrice() {
    const finalPrice =
      parseInt(document.querySelector(".price[data-price]").dataset.price) +
      Object.values(window.nd24.mixandmatch.additionalPrices).reduce(
        (a, b) => a + b,
        0
      );

    const priceItems = [
      document.querySelector(".price__regular .price-item"),
      document.querySelector(".price__sale > .price-item"),
    ];

    for (let i = 0; i < priceItems.length; i++) {
      priceItems[i].innerText = Shopify.formatMoney(Math.floor(finalPrice));
    }
  }

  prepareProductForm() {
    const idInput = this.productForm.querySelector("input[name='id']");

    this.checkEmptySlots();

    if (idInput) {
      idInput.name = "items[0]id";
      idInput.disabled = false;

      this.appendProperties();
    } else {
      this.setVariantProperty = this.productForm.querySelector(
        "input[name='items[0]properties[_BundleProducts]']"
      );

      if (!this.setVariantProperty) {
        this.appendProperties();
      }
    }
  }

  appendProperties() {
    this.setProperty = document.createElement("input");
    this.setProperty.type = "hidden";
    this.setProperty.name = `items[0]properties[_BundleProduct]`;
    this.setProperty.value = window.nd24.mixandmatch.setId;

    this.setVariantProperty = document.createElement("input");
    this.setVariantProperty.type = "hidden";
    this.setVariantProperty.name = `items[0]properties[_BundleProducts]`;
    this.setVariantProperty.value = window.nd24.mixandmatch.selectedVariants
      .map((variant) => variant.id)
      .reduce((a, b) => {
        if (a.indexOf(b) < 0) a.push(b);
        return a;
      }, []);

    this.productForm.append(this.setProperty);
    this.productForm.append(this.setVariantProperty);
  }
  lockSubmitButton() {
    if (
      !this.productFormSubmit.classList.contains(
        "product-form__submit--select-first"
      )
    ) {
      this.productFormSubmit.classList.add(
        "product-form__submit--select-first"
      );

      this.productFormSubmit.querySelector("span").innerText =
        window.mixAndMatchStrings.select_products;

      this.productFormSubmit.addEventListener("click", (event) => {
        const emptyMandatorySlots = Array.from(
          document.querySelectorAll(".mix-and-match__slot--empty")
        ).filter((slot) => {
          return !slot.classList.contains("mix-and-match__slot--optional");
        });

        if (emptyMandatorySlots.length > 0) {
          event.preventDefault();

          const emptyMixAndMatch =
            emptyMandatorySlots[0].closest(".mix-and-match");

          const emptyMixAndMatchButton = emptyMandatorySlots[0].closest(
            ".mix-and-match__modal-button"
          );

          scrollIntoView(
            emptyMixAndMatch,
            {
              align: {
                top: 0.2,
              },
            },
            () => {
              emptyMixAndMatchButton.dispatchEvent(new Event("click"));
            }
          );
        }
      });
    }
  }

  selectProduct(event) {
    const productImage = event.currentTarget
      .querySelector(".mix-and-match__image")
      .cloneNode(true);

    const opener = event.currentTarget.closest(".mix-and-match__modal");
    const openerSlot = opener.openedBy.querySelector(".mix-and-match__slot");
    const variantSelected = event.currentTarget.dataset.variant;

    const isAdditional = opener.openedBy.closest(
      ".mix-and-match__modal-opener-wrapper--additional"
    );

    if (
      isAdditional &&
      opener.openedBy.querySelector(".mix-and-match__slot--empty")
    ) {
      const additionalTemplate = this.querySelector(
        ".mix-and-match__additional-slot"
      ).cloneNode(true);
      const additionalSlot = additionalTemplate.content;
      additionalSlot
        .querySelector(".mix-and-match__remove-button")
        .addEventListener("click", this.removeItem.bind(this));

      this.querySelector(".mix-and-match__slots").append(additionalSlot);
    }

    opener.openedBy.classList.add("mix-and-match__modal-button--selected");
    opener.openedBy
      .closest(".mix-and-match__modal-opener-wrapper")
      .classList.add("mix-and-match__modal-opener-wrapper--selected");
    opener.openedBy.setAttribute("data-variant-selected", variantSelected);
    opener.openedBy.setAttribute(
      "data-variant-price",
      event.currentTarget.dataset.price
    );

    openerSlot.innerHTML = "";
    openerSlot.append(productImage);
    openerSlot.classList.remove("mix-and-match__slot--empty");

    this.inputElementWrapper.innerHTML = "";

    const selectedVariants = document.querySelectorAll(
      ".mix-and-match__modal-button--selected"
    );

    const selectedVariantsIds = Array.from(selectedVariants).map(
      (selectedVariant) => {
        return {
          id: selectedVariant.dataset.variantSelected,
          optional: selectedVariant.querySelector(
            ".mix-and-match__slot--optional"
          )
            ? true
            : false,
          section: selectedVariant.closest("mix-and-match").dataset.count,
        };
      }
    );

    this.setVariantInputs(selectedVariantsIds);
    this.setSelectedVariants();
    this.checkEmptySlots();
    opener.hide();
  }

  setSelectedVariants() {
    const selectedVariants = document.querySelectorAll(
      ".mix-and-match__modal-button--selected"
    );

    const selectedVariantsIds = Array.from(selectedVariants).map(
      (selectedVariant) => {
        return selectedVariant.dataset.variantSelected;
      }
    );

    if (this.setVariantProperty) {
      this.setVariantProperty.value = selectedVariantsIds.join(",");
    }
  }

  setVariantInputs(source) {
    if (source.length <= 0) {
      return;
    }

    this.inputElementWrapper.innerHTML = "";
    let productAdditionalPrice = 0;

    for (let i = 0; i < source.length; i++) {
      const variant = source[i];
      const variantId = variant.id.split(":")[0];
      const variantButton = document.querySelector(
        `.mix-and-match__button[data-variant='${variantId}']`
      );

      let variantInputElement = document.createElement("input");
      variantInputElement.type = "hidden";
      variantInputElement.name = `items[${i + 1}]id`;
      variantInputElement.value = variantId;

      let bundleProperty = document.createElement("input");
      bundleProperty.type = "hidden";
      bundleProperty.name = `items[${i + 1}]properties[_BundleProduct]`;
      bundleProperty.value = window.nd24.mixandmatch.setId;

      let sectionProperty = document.createElement("input");
      sectionProperty.type = "hidden";
      sectionProperty.name = `items[${i + 1}]properties[_BundleSection]`;
      sectionProperty.value = variant.section;

      if (source[i].optional) {
        let optionalProperty = document.createElement("input");
        optionalProperty.type = "hidden";
        optionalProperty.name = `items[${
          i + 1
        }]properties[_BundleProductOptional]`;
        optionalProperty.value = true;
        this.inputElementWrapper.append(optionalProperty);

        let variantPrice = parseInt(variantButton.dataset.price);

        if (this.discount > 0) {
          variantPrice = (variantPrice / 100.0) * (100.0 - this.discount);
        }

        if (this.dataset.count == source[i].section) {
          productAdditionalPrice += variantPrice;
        }
      }

      this.inputElementWrapper.append(variantInputElement);
      this.inputElementWrapper.append(bundleProperty);
      this.inputElementWrapper.append(sectionProperty);
    }

    window.nd24.mixandmatch.additionalPrices[this.blockId] =
      productAdditionalPrice;

    this.setProductPrice();
  }

  removeItem(event) {
    const wrapper = event.currentTarget.closest(
      ".mix-and-match__modal-opener-wrapper"
    );
    const slotButton = wrapper.querySelector(".mix-and-match__modal-button");
    let template = this.querySelector(".mix-and-match__empty-slot").cloneNode(
      true
    );

    if (
      wrapper.classList.contains(
        "mix-and-match__modal-opener-wrapper--additional"
      )
    ) {
      template = this.querySelector(
        ".mix-and-match__empty-slot--additional"
      ).cloneNode(true);
      const emptyAdditionals = this.querySelectorAll(
        ".mix-and-match__modal-opener-wrapper--additional:not(.mix-and-match__modal-opener-wrapper--selected)"
      );

      for (let i = 0; i < emptyAdditionals.length; i++) {
        const element = emptyAdditionals[i];
        element.remove();
      }
    }

    const templateContent = template.content;

    wrapper.classList.remove("mix-and-match__modal-opener-wrapper--selected");

    slotButton.removeAttribute("data-variant-selected");
    slotButton.classList.remove("mix-and-match__modal-button--selected");
    slotButton.innerHTML = "";
    slotButton.append(templateContent);

    const selectedVariants = document.querySelectorAll(
      ".mix-and-match__modal-button--selected"
    );

    const selectedVariantsIds = Array.from(selectedVariants).map(
      (selectedVariant) => {
        return {
          id: selectedVariant.dataset.variantSelected,
          action: "add",
          optional: selectedVariant.querySelector(
            ".mix-and-match__slot--optional"
          )
            ? true
            : false,
          section: selectedVariant.closest("mix-and-match").dataset.count,
        };
      }
    );
    this.setVariantInputs(selectedVariantsIds);
    this.setSelectedVariants();
    this.checkEmptySlots();
  }

  checkEmptySlots() {
    const emptyMandatorySlots = Array.from(
      document.querySelectorAll(".mix-and-match__slot--empty")
    ).filter((slot) => {
      return !slot.classList.contains("mix-and-match__slot--optional");
    });

    if (emptyMandatorySlots < 1) {
      if (this.urlParams.get("bundle_products")) {
        this.productFormSubmit.querySelector("span").innerText =
          window.mixAndMatchStrings.edit;
      } else {
        this.productFormSubmit.querySelector("span").innerText =
          window.variantStrings.addToCart;
      }

      this.productFormSubmit.classList.remove(
        "product-form__submit--select-first"
      );
    }
  }
}

customElements.define("mix-and-match", MixAndMatch);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="locale_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector(".disclosure__list-wrapper"),
    };
    this.elements.button.addEventListener(
      "click",
      this.openSelector.bind(this)
    );
    this.elements.button.addEventListener(
      "focusout",
      this.closeSelector.bind(this)
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute("hidden");
    this.elements.button.setAttribute(
      "aria-expanded",
      (
        this.elements.button.getAttribute("aria-expanded") === "false"
      ).toString()
    );
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define("localization-form", LocalizationForm);

class ProductUpsell extends HTMLElement {
  constructor() {
    super();

    const formRadios = document.querySelectorAll("input[type='radio']");
    const variantIdInput = document.querySelector(
      ".product-form form [name=id]"
    );

    for (let i = 0; i < formRadios.length; i++) {
      const element = formRadios[i];
      element.addEventListener("change", this.variantChanged.bind(this));
    }

    if (variantIdInput) {
      variantIdInput.name = "items[0]id";
      variantIdInput.disabled = false;
    }

    this.checkbox = this.querySelector(".product-upsell__checkbox");
    this.checkbox.addEventListener("change", this.toggleInput.bind(this));
  }
  variantChanged() {
    const productForm = document.querySelector(".product-form form");

    const inputElement = document.createElement("input");
    const highestItemInput = productForm.querySelectorAll(
      "input[name^='items'][name$='id']"
    );

    inputElement.type = "hidden";
    inputElement.name = `items[${highestItemInput.length}]id`;
    inputElement.value = this.checkbox.value;
    inputElement.className = `upsell-input upsell-input--${this.checkbox.value}`;

    if (
      !productForm.querySelector(
        `.upsell-input.upsell-input--${this.checkbox.value}`
      ) &&
      this.checkbox.checked
    ) {
      productForm.append(inputElement);
    }
  }
  toggleInput() {
    const productForm = document.querySelector(".product-form form");
    const inputElement = document.createElement("input");
    const highestItemInput = productForm.querySelectorAll(
      "input[name^='items'][name$='id']"
    );

    inputElement.type = "hidden";
    inputElement.name = `items[${highestItemInput.length}]id`;
    inputElement.value = this.checkbox.value;
    inputElement.className = `upsell-input upsell-input--${this.checkbox.value}`;

    if (
      !productForm.querySelector(
        `.upsell-input.upsell-input--${this.checkbox.value}`
      ) &&
      this.checkbox.checked
    ) {
      productForm.append(inputElement);
    } else {
      const upsellInput = productForm.querySelector(
        `.upsell-input.upsell-input--${this.checkbox.value}`
      );

      if (upsellInput) {
        document
          .querySelector(`.upsell-input.upsell-input--${this.checkbox.value}`)
          .remove();
      }
    }
  }
}

customElements.define("product-upsell", ProductUpsell);
